/** Adapter for settings: the API stores key/value (JSON) rows; the UI reads a flat map.
 *  Only non-sensitive, UI-visible settings are used (agency profile, base currency,
 *  wallet threshold). Secrets are never read or written here. */

export interface ApiSetting {
  id: string;
  key: string;
  value: unknown;
  scope?: string | null;
}

export type SettingsMap = Record<string, unknown>;

export function toSettingsMap(rows: ApiSetting[]): SettingsMap {
  const map: SettingsMap = {};
  for (const row of rows) map[row.key] = row.value;
  return map;
}

export function getStringSetting(map: SettingsMap, key: string, fallback: string): string {
  const v = map[key];
  return typeof v === "string" ? v : fallback;
}

export function getNumberSetting(map: SettingsMap, key: string, fallback: number): number {
  const v = map[key];
  if (typeof v === "number" && Number.isFinite(v)) return v;
  if (typeof v === "string" && v.trim() !== "" && Number.isFinite(Number(v))) return Number(v);
  return fallback;
}

/** Setting keys used by the UI (kept in one place). */
export const SETTING_KEYS = {
  agencyName: "agency.name",
  agencyEmail: "agency.email",
  currencyBase: "currency.base",
  walletThresholdUsd: "wallet.thresholdUsd",
} as const;
